import { useTranslation } from 'react-i18next';
import { icons } from 'smartsuite-ui';
import {
    deprecatedDeleteFavorite,
    deprecatedGetIsFavorite,
    deprecatedGetLandingPageWidgetUserFavorites,
    deprecatedSaveFavorite,
} from './deprecatedFavoriteFunctions';
import {
    deleteFavorite,
    getIsFavorite,
    getLandingPageWidgetUserFavorites,
    saveFavorite,
} from './favoriteFunctions';

export default function useFavorite() {
    const { t } = useTranslation('translation');
    const isPageActionEnabled = window.isFavoritePageActionEnabled;
    const isFavoriteDisabled = window.isKioskMode;

    function getFavoritePageAction(
        itemKey,
        isFavorite,
        pageTitle,
        onDeleteFavorite,
        onSaveFavorite
    ) {
        const source = 'page action';
        /* eslint-disable indent */
        return {
            description: isFavorite ? t('unfavorite') : t('favorite'),
            iconClass: isFavorite ? icons.favoriteFilled : icons.favorite,
            sortOrder: -1,
            onClick: isFavorite
                ? () =>
                      deprecatedDeleteFavorite(itemKey, pageTitle, source).then(
                          onDeleteFavorite
                      )
                : () =>
                      deprecatedSaveFavorite(itemKey, pageTitle, source).then(
                          onSaveFavorite
                      ),
        };
        /* eslint-enable indent */
    }

    if (isPageActionEnabled) {
        return {
            deleteFavorite: deprecatedDeleteFavorite,
            getFavoritePageAction,
            getIsFavorite: deprecatedGetIsFavorite,
            getLandingPageWidgetUserFavorites: deprecatedGetLandingPageWidgetUserFavorites,
            isFavoriteDisabled,
            isPageActionEnabled,
            saveFavorite: deprecatedSaveFavorite,
        };
    }

    return {
        deleteFavorite,
        getIsFavorite,
        getLandingPageWidgetUserFavorites,
        isFavoriteDisabled,
        isPageActionEnabled,
        saveFavorite,
    };
}
